import React from 'react';
import { projects } from '../data/mock';
import { Card, CardContent } from '../components/ui/card';

const Projects = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Header Section */}
      <section className="bg-[#FAFAF8] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold text-[#111111] mb-4">Our Projects</h1>
          <p className="text-lg text-gray-600 max-w-3xl">
            Rock Granites has been the material of choice for prestigious projects worldwide. From luxury hotels to commercial landmarks, our granite delivers enduring beauty and performance.
          </p>
        </div>
      </section>

      {/* Projects Gallery */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {projects.map((project) => (
              <Card key={project.id} className="group overflow-hidden border-0 shadow-sm hover:shadow-xl transition-all duration-300">
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <CardContent className="p-6">
                  <span className="inline-block px-3 py-1 bg-[#FAFAF8] text-xs font-semibold text-[#111111] rounded-full mb-3">
                    {project.category}
                  </span>
                  <h3 className="text-2xl font-semibold mb-2 text-[#111111]">{project.title}</h3>
                  <p className="text-gray-600">{project.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-[#111111] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold mb-2">500+</div>
              <div className="text-gray-400 text-sm">Projects Completed</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">40+</div>
              <div className="text-gray-400 text-sm">Countries Served</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">10K+</div>
              <div className="text-gray-400 text-sm">Container Loads</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">25+</div>
              <div className="text-gray-400 text-sm">Years Experience</div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 bg-[#FAFAF8]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-[#111111] mb-12 text-center">What Our Clients Say</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <Card>
              <CardContent className="p-6">
                <p className="text-gray-600 mb-4 italic">
                  "Consistent quality and reliable delivery schedules. Rock Granites has become our trusted partner for Indian granite."
                </p>
                <div className="text-sm">
                  <div className="font-semibold text-[#111111]">Leading Stone Importer</div>
                  <div className="text-gray-500">Vietnam</div>
                </div>
              </CardContent>
            </Card>
            <Card>
              <CardContent className="p-6">
                <p className="text-gray-600 mb-4 italic">
                  "The grading consistency across multiple container loads is exceptional. Perfect for our large-scale projects."
                </p>
                <div className="text-sm">
                  <div className="font-semibold text-[#111111]">Architectural Firm</div>
                  <div className="text-gray-500">Turkey</div>
                </div>
              </CardContent>
            </Card>
            <Card>
              <CardContent className="p-6">
                <p className="text-gray-600 mb-4 italic">
                  "Professional export documentation and logistics support. Makes international procurement seamless."
                </p>
                <div className="text-sm">
                  <div className="font-semibold text-[#111111]">Construction Group</div>
                  <div className="text-gray-500">Egypt</div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Projects;